import { render, staticRenderFns } from "./pre_select.vue?vue&type=template&id=4c545a70&scoped=true"
import script from "./pre_select.vue?vue&type=script&lang=js"
export * from "./pre_select.vue?vue&type=script&lang=js"
import style0 from "./pre_select.vue?vue&type=style&index=0&id=4c545a70&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c545a70",
  null
  
)

export default component.exports